/**
 * Master Schedule gates the shared dynamic week-start value behind its OWN flag
 * (`ScheduleTemplateRuntimeWeekStart`). When the flag is OFF the schedule template stays
 * Sunday-anchored (0) regardless of the shared `viewStartDay` — which may be non-zero because
 * Staffing/Profile set it under the unified value — so the biweekly phase math is unchanged.
 */
export const resolveEffectiveWeekStartDay = (isRuntimeWeekStartEnabled: boolean, sharedViewStartDay: number): number =>
	isRuntimeWeekStartEnabled ? sharedViewStartDay : 0;
